"use client"
/* */
import { isRemoteComponentRendererProps } from './remote.mjs';
import React from 'react';

const cloneElement = (element, props) => {
  const existingProps = element.props;
  if (isRemoteComponentRendererProps(existingProps)) {
    Object.assign(existingProps.element.properties, props);
  }
  return React.cloneElement(element, props);
};

export { cloneElement };
//# sourceMappingURL=cloneElement.mjs.map
